module.exports = __webpack_public_path__ + "img/74.ca18c9fa.jpg";